import { IIconProps } from './icon';

interface IIconDataBaseProps extends IIconProps {
  isActive?: boolean;
}

export const IcoDataBase = ({
  style = {},
  cy,
  isActive,
}: IIconDataBaseProps) => {
  return (
    <svg
      width="22"
      height="23"
      viewBox="0 0 22 23"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={style}
      data-cy={`DataBaseIcon${cy}`}
    >
      <path
        d="M12.99 20.0051L5.62 14.2751L4 15.5351L13 22.5351L22 15.5351L20.37 14.2651L12.99 20.0051ZM13 17.4651L20.36 11.7351L22 10.4651L13 3.46509L4 10.4651L5.63 11.7351L13 17.4651Z"
        fill="white"
      />
      {isActive && <circle cx="4.5" cy="4.5" r="4.5" fill="#BA96D9" />}
    </svg>
  );
};
